
//keys for session
export const KeyForSessionForIsCompanyOrPrivate="IsCompanyOrPrivate";
export const KeyForSessionForPrivateContact="privatContact";
export const KeyForSessionForShipInfo="KeyForSessionForShipInfo";
export const KeyForSessionForCompanyContact="KeyForSessionForCompanyContact";



//private or compnay
export const IsPrivateContact="IsPrivateContactId";
export const PrivateOrCompanyLegend="Steg 1 - Aktör";


//company

export const CompanyLegend="Uppgifter om sökande";
export const CompanyLegendH2="Steg 2 - Kontaktuppgifter";

export const CompanyAddressLegend="Adressuppgifter";
export const CompanyLabel="Organisation";
export const CompanyPlaceHolder="Ange organisation";
export const CompanyError="Ange organisation";
export const CompanyId="companyId";

export const OrgNoLabel="Organisationsnummer";
export const OrgNoPlaceHolder="Ange organisationsnummer t.ex. 202100-4359";
export const OrgNoError="Ange organisationsnummer t.ex. 202100-4359";
export const OrgNoId="orgNoId";

export const ContactLabel="Kontaktperson";
export const ContactPlaceHolder="Ange kontaktperson";
export const ContactError="Ange kontaktperson";
export const ContactId="contactId";




//privateperson
export const PrivateLegend="Uppgifter om sökande";
export const PrivateLegendH2="Steg 2 - Kontaktuppgifter";
export const PrivateAddressLegend="Adressuppgifter";
export const FirstnameLabel="Förnamn";
export const FirstnamePlaceHolder="Ange förnamn";
export const FirstnameError="Ange förnamn";
export const FirstnameId="firstnameId";

export const LastnameLabel="Efternamn";
export const LastnamePlaceHolder="Ange efternamn";
export const LastnameError="Ange efternamn";
export const LastnameId="lastnameId"

export const SSNLabel="Personummer";
export const SSNPlaceHolder="Ange personnummer YYYYDDMM-XXXX";
export const SSNError="Ange personnummer YYYYDDMM-XXXX";
export const SSNId="ssnId"


//address

export const Address1Label="T.ex. c/o";
export const Address1PlaceHolder="C/o";
export const Address1Error="Ange t.ex. c/o" ;
export const Address1Id="Gatuadress1Id"

export const Address2Label="Gatuadress";
export const Address2PlaceHolder="Ange gatuadress";
export const Address2Error="Ange gatuadress";
export const Address2Id="Gatuadress2Id"

export const ZipcodeLabel="Postnummer";
export const ZipcodePlaceHolder="Ange postnummer";
export const ZipcodeError="Ange postnummer";
export const ZipcodeId="zipcodeId"

export const CityLabel="Postort";
export const CityPlaceHolder="Ange postort";
export const CityError="Ange postort";
export const CityId="cityId";


export const CountryLabel="Land";
export const CountryPlaceHolder="Ange land om ej angivet Sverige";
export const CountryError="Ange land";
export const CountryId="countryId";

export const EmailLabel="E-post";
export const EmailPlaceHolder="Ange e-post";
export const EmailError="Ange e-post";
export const EmailId="emailId";
export const EmailPatternError="Angivna e-post är i ogiltigt format (info@pts.se)";

export const PhoneLabel="Telefon"
export const PhoneError="Ange telefon"
export const PhoneId="phoneId"


//fakturaadress
export const InvoiceAddress1Label="Fakturaadress (rad 1)";
export const InvoiceAddress1PlaceHolder="Ange fakturaadress (rad 1)";
export const InvoiceAddress1Id="invoiceAddress1Id";

export const InvoiceAddress2Label="Fakturaadress (rad 2)";
export const InvoiceAddress2PlaceHolder="Ange Fakturaadress (rad 2)";
export const InvoiceAddress2Id="invoiceAddress2Id";

export const InvoiceRefLabel="Fakturareferens"
export const InvoiceRefPlaceHolder="Ange fakturareferens"
export const InvoiceRefId="invoiceRefId"

export const InvoiceZipcodeLabel="Postnummer";
export const InvoiceZipcodePlaceHolder="Ange postnummer";
export const InvoiceZipcodeError="Ange postnummer";
export const InvoiceZipcodeId="invoiceZipcodeId"

export const InvoiceCityLabel="Postort";
export const InvoiceCityPlaceHolder="Ange postort";
export const InvoiceCityError="Ange postort";
export const InvoiceCityId="invoiceCityId";

export const InvoiceCountryLabel="Land";
export const InvoiceCountryPlaceHolder="Ange land om ej angivet Sverige";
export const InvoiceCountryError="Ange land";
export const InvoiceCountryId="invoiceCountryId";

export const InvoiceAddressChkLabel="Annan fakturaadress";
export const InvoiceAddressChkName="invoiceChkName";
export const InvoiceAddressChkId="invoiceChkId";







//shipinfo
export const ShipInfoLegend="Uppgifter om fartyget"
export const ShipInfoLegendH2="Steg 3 - Fartygsuppgifter"

export const ShipNameLabelLang="Fartygets namn";
export const ShipNameLang="Ange fartygets namn";
export const ShipNameId="shipnameId";

/*export const ShipFormerNameLabelLang="Båtens tidigare namn";
export const ShipFormerNameLang="Ange båtens tidigare namn";
export const ShipFormerNameId="formerShipnameId";*/

export const BoatSizeLengthLang="Fartygets längd (m)";
export const BoatSizeLengthLabelLang="Ange fartygets längd (m)";
export const BoatSizeLengthId="boatsizeLengthId";

//export const BoatSizeWidthLang="Fartygets bredd (m)";
//export const BoatSizeWidthLabelLang="Ange fartygets bredd (m)";
//export const BoatSizeWidthId="boatsizeWidthId";

export const Mmsi="Eventuell tilldelning av MMSI-nummer";
export const MmsiLabel="Ange eventuell tilldelning av MMSI-nummer";
export const MmsiId="mmsiId";
export const MmsiCheckboxLabel="Ja, tilldelning av MMSI-nummer önskas";

export const DistrictLabel="Distriktbeteckning";
export const DistrictLabelError="Ange distriktbeteckning";
export const DistrictId="districtId";


export const Epirb="Tillstånd för nödradiosändare - EPIRB";
export const EpirbLabel="Ange tillstånd för nödradiosändare - EPIRB";

export const Epirb1215Id="epirb1215Id";
export const EpirbCheckbox1215IdLabel="Ja, tillstånd för EPIRB (nödradiosändare) med frekvens 121,5 MHz önskas";

export const EpirbCheckboxLabel406="Ja, tillstånd för EPIRB (nödradiosändare) med frekvens 406 MHz önskas";
export const Epirb406Id="epirb406Id";

export const AISCheckboxId="aisId";
export const AISCheckboxLabel="Ja, AIS önskas";

export const UseForMarketingLabel="Mina uppgifter får användas till marknadsföring";
export const UseForMarketingId="marketingId";
export const UseForMarketingLabelPreviewYes="Ja, mina uppgifter får användas till marknadsföring";
export const UseForMarketingLabelPreviewNo="Mina uppgifter får INTE användas till marknadsföring";

export const HandheldCheckBoxLabel="Endast handhållen enhet";
export const HandheldCheckBoxId="handheldId";

export const Comment="Ange exempelvis övrig utrustning eller om specifikt MMSI-nummer önskas."
export const CommentLabel="Övrig information - exempelvis övrig utrustning/tjänst, om specifikt MMSI-nummer eller anropssignal önskas";
export const CommentPreviewLabel="Övrig information";
export const CommentId="commentId";

export const ShouldRegisterSjoFartverket=<div className="alert alert-info">Nödradiosändare ska även registreras hos Sjöfartsverkets <a href="https://www.sjofartsverket.se/sv/om-oss/kontakta-oss/sjofartsverkets-sjo--och-flygraddningscentral/" target="_blank" className="fontWhiteBold">sjöräddningscentral (JRCC) </a></div>

export const ShipClassLabel="Välj fartygklass";
export const ShipClassError="Välj fartygklass";
export const ShipClassId="shipclassId";
export const ValidOptions = ['Fritidsfartyg','Fiskefartyg', 'Fartyg i statlig tjänst', 'Handelsfartyg','Specialfartyg','Militärfartyg','Sjöräddningsfartyg','Ospecifierad'];

export const CallsignLabel="Anropssignal från fartygsregistret";
export const CallsignError="Ange anropssignal";
export const CallsignId="callsignId";


export const OnlyDigitsError="Endast siffror"


export const SpecialPostAddress="Särskild postadress annan än folkbokföringsadressen";
export const SpecialPostAddressPreview="Särskild postadress";
export const SpecialPostAddressId="specialPostAddressId";

export const NoSwedishPersonNo="Har ej svenskt personnummer";
export const NoSwedishPersNoId="noswedishpersnoid";



//navigate
export const NavStartPage="/vhf/start";
export const NavPrivateContactInfo="/vhf/privateContact";
export const NavCompanyContactInfo="/vhf/companyContact";
export const NavShipInfo="/vhf/shipInfo";
export const NavPreview="/vhf/preview";
export const NavThanks="/vhf/thanks";

export const SwedenDefaultCountry="Sverige"


//preview
export const PreviewLegend="Förhandsgranskning"
export const PreviewLegendH2="Steg 4 - Granska och skicka"
export const ContactHeadlinePrivate="Kontaktuppgifter privat";
export const ContactHeadlineCompany="Kontaktuppgifter företag";
export const ShipInfoHeadline="Fartygsuppgifter";
export const ContactInvoiceCompany="Fakturaadress";

//stepper
export const StepperLabel = [
    'Aktör',
    'Kontaktuppgifter',
    'Fartygsuppgifter',
    'Granska och skicka'
    ];

  //button
  export const ButtonSendDisplay="Skicka";
  export const ButtonPreviousDisplay="Föregående";
  export const ButtonNextDisplay="Nästa";
  export const ButtonNewCase="Nytt ärende";


  //header
  export const HeaderStepper= "Ansökan om nytt tillstånd för VHF-radiosändare";
